import { render, staticRenderFns } from "./programs2IB.vue?vue&type=template&id=26e839b6"
import script from "./programs2IB.vue?vue&type=script&lang=js"
export * from "./programs2IB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports